export const ACTIONS = {
  INIT_CAMPAIGNS: 'INIT_CAMPAIGNS',
  CHANGE_FILTERED_CAMPAIGNS: 'CHANGE_FILTERED_CAMPAIGNS',
  CHANGE_FILTER_VALUE: 'CHANGE_FILTER_VALUE',
  CHANGE_SETTINGS_SHOW: 'CHANGE_SETTINGS_SHOW'
};